import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../data/volumes';
import { FlowLine } from './FlowLine';
import { Ornament } from './Ornament';
export function TomosSection() {
  return <section className="border-t border-primary/10 bg-surface px-4 py-20 sm:py-28" data-id="element-368" data-mp="1p4c0q4oesgv8">
      <div className="mx-auto max-w-6xl" data-id="element-369" data-mp="1u1bzduixihcb">
        <div className="mx-auto max-w-3xl text-center" data-id="element-370" data-mp="xce1i3fvu3ax">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-371" data-mp="xdyvnryabk89">
            The 6 volumes
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-foreground sm:text-4xl" data-id="element-372" data-mp="11fstztl0cc59">
            The Complete <span className="italic text-primary" data-id="element-373" data-mp="16f5ck24uix21">6-Volume</span>{' '}
            Barre Instructor System
          </h2>
          <Ornament className="mt-5" data-id="element-374" data-mp="2hshnewz0wfxp" />
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-375" data-mp="2hrpq9hps2a5b">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex h-full flex-col rounded-xl border border-accent/30 p-6 shadow-card sm:p-8 ${index % 2 === 0 ? 'bg-background' : 'bg-surface-subtle'}`} data-id="element-376" data-mp="2mprbo9aoeljy" data-mpi={index}>
              <div className="flex items-center justify-between gap-3" data-id="element-377" data-mp="22y4i9hv2k2ua">
                <p className="font-display text-sm font-semibold uppercase tracking-[0.16em] text-primary" data-id="element-378" data-mp="22wtdbepw0p1l">
                  {volume.number}
                </p>
                <span className="inline-flex whitespace-nowrap rounded-full border border-accent/50 bg-surface px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-primary-strong" data-id="element-379" data-mp="1tz9e0bbl52tm">
                  {volume.classes}
                </span>
              </div>
              <span className="mt-3 block h-px w-12 bg-accent" aria-hidden="true" data-id="element-380" data-mp="1abwmplla64ry" />
              <h3 className="mt-4 text-2xl font-semibold leading-snug text-foreground" data-id="element-381" data-mp="1fbsgyt46ehub">
                {volume.title}
              </h3>
              <p className="mt-3 border-l-2 border-accent pl-4 text-sm font-medium leading-6 text-primary-strong" data-id="element-382" data-mp="11ct1aayn5daa">
                {volume.subtitle}
              </p>
              <div className="mt-6" data-id="element-383" data-mp="1t25r924ji8mt">
                {volume.problem.map((paragraph, pIndex) => <p key={paragraph} className={`text-sm leading-6 text-muted-foreground ${pIndex > 0 ? 'mt-2' : ''}`} data-id="element-384" data-mp="1y2a9oxp0ddfo" data-mpi={pIndex}>
                    {paragraph}
                  </p>)}
              </div>
              {volume.extraList && <ChecklistBlock label={volume.extraList.label} items={volume.extraList.items} data-id="element-385" data-mp="2c19yc5citsbu" />}
              <ChecklistBlock label={volume.listLabel} items={volume.bullets} data-id="element-386" data-mp="5d9jybs7szqy" />
              {volume.flow && <FlowLine className="mt-6" label={volume.flow.label} steps={volume.flow.steps} data-id="element-387" data-mp="eg7mmonzesd" />}
              {volume.highlight && <ChecklistBlock label={volume.highlight.label} items={volume.highlight.items} data-id="element-388" data-mp="a50zzsdqvn2u" />}
              <div className="mt-auto pt-7" data-id="element-389" data-mp="3dkq00h7643to">
                <div className="rounded-lg border border-primary/20 bg-muted p-4 text-sm leading-6 text-foreground" data-id="element-390" data-mp="3dm001bxkzm2y">
                  <strong className="font-semibold text-primary-strong" data-id="element-391" data-mp="3sja96emr4fvi">
                    Result:{' '}
                  </strong>
                  {volume.result.join(' ')}
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function ChecklistBlock({
  label,
  items
}: {
  label?: string;
  items: string[];
}) {
  return <div className="mt-5" data-id="element-392" data-mp="38iiezxmu5f0y">
      {label && <p className="text-sm font-semibold text-foreground" data-id="element-393" data-mp="3dg0phsgi42b2">{label}</p>}
      <ul className="mt-2 grid gap-x-4 gap-y-1.5 sm:grid-cols-2" data-id="element-394" data-mp="3dgafhg1jq9gr">
        {items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-6 text-muted-foreground" data-id="element-395" data-mp="3hgaup2wgyoov">
            <CheckIcon size={16} className="mt-1 shrink-0 text-success" aria-hidden="true" data-id="element-396" data-mp="3mi9vc50tr7i4" />
            {item}
          </li>)}
      </ul>
    </div>;
}